export const fr = {
  $vuetify: {
    // C
    close: 'Fermer',
    chooseOption: 'Choisir une option',
    collectionTitle: 'Version du produit',

    // P
    projectHasBeenSaved: 'Le projet a été sauvegardé',
    projectCodeSummary: 'Utilisez le code suivant pour le rouvrir et le continuer plus tard',

    // Q
    qrcodeSummary: 'Scannez le QR code avec votre smartphone pour voir le produit en réalité augmentée',

    // S
    seeInAR: 'Voir chez soi',

  },
}
